import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { IrisEnvironmentService } from '@iris/common/services/environment.service';
import { IrisXHeadersEnum } from '@iris/common/models/IrisXHeadersEnum';
import { IrisGlobalSandbox } from '@iris/common/redux/global.sandbox';
import { resolveAppAlias } from '@iris/common/utils/appAlias.utils';
import { IRIS_APPLICATION_ALIAS } from '@iris/common/models/IrisApplication';

@Injectable()
export class IrisSetServiceNameInterceptor implements HttpInterceptor {
  private readonly environmentService = inject(IrisEnvironmentService);
  private readonly globalSandbox = inject(IrisGlobalSandbox);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const appAlias = resolveAppAlias(this.globalSandbox.appAlias(), this.globalSandbox.savedAppAlias || IRIS_APPLICATION_ALIAS);
    const headers: Record<string, string> = {
      [IrisXHeadersEnum.SERVICE_NAME]: `frontend-ng | ${this.environmentService.env.version} | ${window.location.origin} | ${window.navigator.userAgent}`,
      [IrisXHeadersEnum.APP_NAME]: appAlias ? appAlias : IRIS_APPLICATION_ALIAS,
    };

    return next.handle(req.clone({ setHeaders: headers }));
  }
}
